export default "__VITE_ASSET__e370601a__"